import { Box } from '@mui/material';
import React from 'react';
import { CustomDataGrid } from './CustomDataGrid';
// import { GridToolbar } from '@mui/x-data-grid-pro';


const PaginatedDataGrid = ({ columns, rows, columnVisibilityModel = {
  id: false,
  data_shared_on: false,
  pack: false,
  "condition_/_stage": false,
  other_test: false,
  "s.no.": false
}, ...otherProps
}) => {
  // const columns = Object.keys(array[0]).map((item) => ({
  //   field: item,
  //   width: 200,
  //   headerName: item?.split("_").join(" ").toUpperCase()
  // }));
  // console.log(columns);
  return (
    <Box sx={{
      width: "100%",
    }}>
      <CustomDataGrid
        slots={{
          // toolbar: GridToolbar
        }}
        columns={columns}
        rows={rows}
        pagination
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        pageSizeOptions={[10, 25, 50, 100]}
        columnVisibilityModel={columnVisibilityModel}
        {...otherProps}
      />
    </Box>
  );
};

export default PaginatedDataGrid;